<section class="reasons">
  <div class="container">
    <div class="reasons__header">
      <!-- Decorative compass -->
      <div class="reasons__compass">
        <svg viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
          <polygon points="50,2 54,50 50,40 46,50" fill="white" opacity="0.9"/>
          <polygon points="50,98 54,50 50,60 46,50" fill="white" opacity="0.5"/>
          <polygon points="98,50 50,46 60,50 50,54" fill="white" opacity="0.5"/>
          <polygon points="2,50 50,46 40,50 50,54" fill="white" opacity="0.5"/>
          <polygon points="78,22 52,50 55,47" fill="white" opacity="0.35"/>
          <polygon points="22,22 48,50 45,47" fill="white" opacity="0.35"/>
          <polygon points="78,78 52,50 55,53" fill="white" opacity="0.35"/>
          <polygon points="22,78 48,50 45,53" fill="white" opacity="0.35"/>
          <circle cx="50" cy="50" r="22" stroke="rgba(255,255,255,0.2)" stroke-width="1" fill="none"/>
          <circle cx="50" cy="50" r="34" stroke="rgba(255,255,255,0.1)" stroke-width="0.8" fill="none"/>
          <circle cx="50" cy="50" r="6" fill="white" opacity="0.8"/>
          <circle cx="50" cy="50" r="2.5" fill="#060b18"/>
          <text x="47" y="16" font-size="8" fill="white" opacity="0.7" font-family="Inter,sans-serif" font-weight="700">N</text>
          <text x="47" y="92" font-size="8" fill="white" opacity="0.5" font-family="Inter,sans-serif" font-weight="400">S</text>
          <text x="86" y="53" font-size="8" fill="white" opacity="0.5" font-family="Inter,sans-serif" font-weight="400">E</text>
          <text x="6" y="53" font-size="8" fill="white" opacity="0.5" font-family="Inter,sans-serif" font-weight="400">W</text>
        </svg>
      </div>
      <span class="section-tag">{{ t().reasons_tag }}</span>
      <h2 class="section-title"><span>{{ t().reasons_title_1 }}</span> {{ t().reasons_title_2 }}</h2>
    </div>

    <div class="reasons__grid">
      @for (r of reasons(); track r.num) {
        <div class="reason-card" [style.animation-delay]="(r.num * 0.07) + 's'">
          <span class="reason-num">0{{ r.num }}</span>
          <h4>{{ r.title }}</h4>
          <p>{{ r.desc }}</p>
        </div>
      }
    </div>
  </div>
</section>
